// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderNavBar_wrapper__sCT2N","title":"OrderNavBar_title__3nDj2","count":"OrderNavBar_count__3_iNy","isSelected":"OrderNavBar_isSelected__itorR"};